/*
  Keyboard accessibility for the GoodStone header navigation.

  The nav opens its mega menus from `mouseover` only (z__jsMegaMenu.js), which
  leaves keyboard users with no way in. This adds the focus/keyboard path on top
  of that without touching the hover path: both routes drive the same `is-active`
  class that styles.css.liquid already keys the mega menu off.

  Listeners are delegated from `document` because z__jsMegaMenu.js clones the
  mega menu panels into the nav after section init, so the nodes do not exist yet
  when this file runs.
*/
(function () {
  'use strict';

  var ITEM = '.header__menu .header__item';
  var uid = 0;

  function triggerOf(item) {
    return item.querySelector('.header__link');
  }

  function panelOf(item) {
    return item.querySelector('.mega-menu__section') || item.querySelector('.navbar-dropdown');
  }

  // Only items that actually own a panel are treated as disclosure triggers.
  function isDisclosure(item) {
    return !!(item && panelOf(item));
  }

  function wire(item) {
    var t = triggerOf(item);
    var p = panelOf(item);
    if (!t || !p || t.getAttribute('data-a11y-wired')) return;
    if (!p.id) p.id = 'header-panel-' + ++uid;
    t.setAttribute('aria-haspopup', 'true');
    t.setAttribute('aria-expanded', 'false');
    t.setAttribute('aria-controls', p.id);
    t.setAttribute('data-a11y-wired', '1');
  }

  function close(item) {
    if (!item) return;
    var mega = item.querySelector('.mega-menu__section');
    if (mega) mega.classList.remove('is-active');
    var labels = item.querySelectorAll('label.is-active');
    for (var i = 0; i < labels.length; i++) labels[i].classList.remove('is-active');
    item.classList.remove('show-dropdown');
    var t = triggerOf(item);
    if (t) t.setAttribute('aria-expanded', 'false');
  }

  function closeAll(except) {
    var items = document.querySelectorAll(ITEM);
    for (var i = 0; i < items.length; i++) {
      if (items[i] !== except) close(items[i]);
    }
  }

  function open(item) {
    if (!isDisclosure(item)) {
      closeAll(null);
      return;
    }
    wire(item);
    closeAll(item);
    var mega = item.querySelector('.mega-menu__section');
    if (mega) mega.classList.add('is-active');
    var label = item.querySelector('label');
    if (label) label.classList.add('is-active');
    item.classList.add('show-dropdown');
    var t = triggerOf(item);
    if (t) t.setAttribute('aria-expanded', 'true');
  }

  // Open on focus, close once focus leaves the nav entirely.
  document.addEventListener('focusin', function (e) {
    var target = e.target;
    if (!target || !target.closest) return;
    if (!target.closest('.header__menu')) {
      closeAll(null);
      return;
    }
    var item = target.closest(ITEM);
    if (item && isDisclosure(item)) open(item);
    else closeAll(null);
  });

  document.addEventListener('keydown', function (e) {
    var target = e.target;
    if (!target || !target.closest) return;
    var item = target.closest(ITEM);

    if (e.key === 'Escape' || e.key === 'Esc') {
      if (!item) return;
      var trigger = triggerOf(item);
      close(item);
      if (trigger) trigger.focus();
      e.preventDefault();
      return;
    }

    if (!item || !isDisclosure(item)) return;
    var t = triggerOf(item);

    // A trigger with no href is exposed as a button, so Enter/Space must open it.
    if (target === t && !t.hasAttribute('href') && (e.key === 'Enter' || e.key === ' ')) {
      open(item);
      e.preventDefault();
      return;
    }

    // ArrowDown from the trigger moves into the panel.
    if (target === t && e.key === 'ArrowDown') {
      open(item);
      var first = panelOf(item).querySelector('a[href], button');
      if (first) first.focus();
      e.preventDefault();
    }
  });

  function wireAll() {
    var items = document.querySelectorAll(ITEM);
    for (var i = 0; i < items.length; i++) {
      if (isDisclosure(items[i])) wire(items[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wireAll);
  } else {
    wireAll();
  }
  // The panels are cloned in after section init; re-wire once they land.
  window.addEventListener('load', wireAll);
})();
